
<div>
  <b-row v-if="loading" align-h="center">
    <SmallSpinner :size="50" centered />
  </b-row>

  <b-row
    v-for="(deliverySlot, key) in skipAllDeliverySlots"
    v-if="!loading"
    :key="key"
    class="w-100 mt-3"
  >
    <b-col cols="12" sm="12" md="5" lg="7" class="mb-3">
      <span>
        {{ showSlotTime(key) }}
        <span v-if="isSkipped(deliverySlot)">(skipped)</span>
        <b-badge
          v-if="!isSkipped(deliverySlot)"
          :variant="getStatusVariant(deliverySlot)"
          class="ml-2"
        >
          {{ getStatusLabel(deliverySlot) }}
        </b-badge>
      </span>
    </b-col>

    <b-col class="rotation-buttons" cols="12" sm="12" md="7" lg="5">
      <b-row cols="12" sm="12" md="4" lg="4" class="rotation-button">
        <b-button
          class="btn btn-secondary ml-2"
          :disabled="
            !deliverySlot.is_ready &&
              !deliverySlot.has_selection &&
              deliverySlot.status !== 'ordered'
          "
          @click="
            deliverySlot.scheduled || deliverySlot.has_selection
              ? viewMealsSelectionForSlot(deliverySlot)
              : selectMealsForSlot(key)
          "
        >
          <span
            v-if="
              deliverySlot.scheduled ||
                deliverySlot.has_selection ||
                deliverySlot.status === 'ordered'
            "
          >
            VIEW MEALS
          </span>
          <span
            v-else-if="
              deliverySlot.is_ready || deliverySlot.status === 'ready'
            "
          >
            SELECT MEALS
          </span>
          <span v-else> PENDING </span>
        </b-button>
      </b-row>

      <b-row cols="12" sm="12" md="4" lg="4" class="rotation-button">
        <b-button
          class="ml-2 skip-button"
          :class="isSkipped(deliverySlot) ? 'disabled' : ''"
          :disabled="isSkipped(deliverySlot)"
          @click="
            isSkipped(deliverySlot)
              ? openDeleteModal(key)
              : openSkipModal(key)
          "
        >
          <span>{{ isSkipped(deliverySlot) ? 'Unskip' : 'Skip' }}</span>
        </b-button>
      </b-row>
    </b-col>
  </b-row>

  <!-- <div v-else class="mt-3">
      No slots available for the selected date.
  </div> -->

  <b-modal
    size="medium"
    :visible="skipSlot !== null"
    title="Skip delivery for this date?"
    ok-title="Skip"
    @hidden="skipSlot = null"
    @ok="submitSkippedSlot(skipSlot)"
  >
    <p>
      <b>NOTICE:</b> Skip slot for this date {{ showSlotTime(skipSlot) }}?
    </p>
  </b-modal>

  <b-modal
    :visible="deleteSlot !== null"
    title="Delete this skipped slot delivery for this date?"
    ok-title="Delete"
    @hidden="deleteSlot = null"
    @ok="deleteSkippedSlot(deleteSlot)"
  >
    <p>
      <b>NOTICE:</b> Skip slot for this date {{ showSlotTime(deleteSlot) }}?
    </p>
  </b-modal>
</div>
